import { useLatest, useLocalStorageState } from 'ahooks'

import { LoginTrackName, SignUpTrackName } from '../helpers/trackName'

export const useTrackAuthInfo = () => {
  const [trackAuthInfo, setTrackAuthInfo] = useLocalStorageState<{
    [SignUpTrackName]: string
    [LoginTrackName]: string
  }>('track-auth-info', {
    defaultValue: {
      [SignUpTrackName]: '',
      [LoginTrackName]: '',
    },
    listenStorageChange: true,
  })

  const trackAuthInfoLatest = useLatest(trackAuthInfo)

  return {
    setTrackAuthInfo,
    trackAuthInfoLatest,
  }
}
